import { render, staticRenderFns } from "./CommentsBlock.vue?vue&type=template&id=99ae9282&"
import script from "./CommentsBlock.vue?vue&type=script&lang=js&"
export * from "./CommentsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports